import React, { useState } from "react";
import { withMonogramContext } from "./MonogramContext";
import DecorativeSvgCalibration from "./DecorativeSvgCalibration";

const Range = ({ min = 0, max = 100, value, onChange, label }) => (
  <div>
    <input type="range" min={min} max={max} value={value} onChange={onChange} />
    <label htmlFor={label}>{label}</label>
  </div>
);

function MonogramCalibrationDrawer({ monogramBounds, chosenFont }) {
  const { tempBounds, setTempBounds } = monogramBounds;

  const [copied, setCopied] = useState(false);

  const handleBoundUpdate = (bound, axis, value) => {
    setTempBounds({
      ...tempBounds,
      [bound]: {
        ...tempBounds[bound],
        [axis]: Number(value),
      },
    });
  };

  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(JSON.stringify(tempBounds));

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div>
      <p>Top left</p>
      <Range
        max={tempBounds.bottom_right.x}
        label={`X (${tempBounds.top_left.x}%)`}
        value={tempBounds.top_left.x}
        onChange={(e) => handleBoundUpdate("top_left", "x", e.target.value)}
      />
      <Range
        max={tempBounds.bottom_right.y}
        label={`Y (${tempBounds.top_left.y}%)`}
        value={tempBounds.top_left.y}
        onChange={(e) => handleBoundUpdate("top_left", "y", e.target.value)}
      />
      <p>Bottom right</p>
      <Range
        min={tempBounds.top_left.x}
        label={`X (${tempBounds.bottom_right.x}%)`}
        value={tempBounds.bottom_right.x}
        onChange={(e) => handleBoundUpdate("bottom_right", "x", e.target.value)}
      />
      <Range
        min={tempBounds.top_left.y}
        label={`Y (${tempBounds.bottom_right.y}%)`}
        value={tempBounds.bottom_right.y}
        onChange={(e) => handleBoundUpdate("bottom_right", "y", e.target.value)}
      />
      <p>
        <strong>
          Copy the below value to the <i>Bounding rectangle</i> metafield in Accentuate.
        </strong>{" "}
        You can switch to other drawers and customize the product to see how the bounds react, but
        these bounds will not save until it is done so in Accentuate.
      </p>
      <code
        style={{
          backgroundColor: "black",
          color: "white",
          borderRadius: "1rem",
          display: "block",
          marginBottom: "1rem",
          padding: "1rem",
        }}
      >
        {JSON.stringify(tempBounds)}
      </code>
      <button onClick={handleCopy}>{copied ? "Copied" : "Copy"}</button>
      {!!chosenFont?.decorative_svg && <DecorativeSvgCalibration />}
    </div>
  );
}

export default withMonogramContext(MonogramCalibrationDrawer);
